// Dated owner-confirmed status, recorded in JASONS_DIRECTIVE.md. The retained
// offline submission draft is a separate artifact, not evidence of portal state.
export const pluginLaunch = {
  status: 'In OpenAI review',
  timing: 'Public release is subject to OpenAI’s approval. A release date has not been confirmed.',
  updatedAt: '2026-10-12',
  updatedLabel: 'October 12, 2026',
} as const;
